<div class="preview">
  <div class="preview__header">
    <mat-icon>visibility</mat-icon>
    <span class="preview__title">Customer preview</span>
    <span class="preview__spacer"></span>
    <span class="preview__live">Live order</span>
  </div>

  <div class="preview__body">
    <p class="preview__intro">
      What <strong>{{ partyName }}</strong> sees on their contact page.:
    </p>

    <p class="preview__eyebrow">Your people<span class="sgl-arrows" aria-hidden="true"></span></p>
    @if (visiblePeople.length) {
      <div class="preview__cards">
        @for (person of visiblePeople; track person.contactId) {
          <app-contact-item [contact]="toContact(person)"></app-contact-item>
        }
      </div>
    } @else {
      <div class="preview__empty">No people will be shown to customers.</div>
    }

    <p class="preview__eyebrow">Departments<span class="sgl-arrows" aria-hidden="true"></span></p>
    @if (visibleDepartments.length) {
      <div class="preview__cards">
        @for (department of visibleDepartments; track department.contactId) {
          <app-department-item [department]="toDepartmentContact(department)"></app-department-item>
        }
      </div>
    } @else {
      <div class="preview__empty">No departments will be shown to customers.</div>
    }
  </div>

  <div class="preview__footer">
    <mat-icon>info</mat-icon>
    Inactive contacts and hidden fields are excluded.
  </div>
</div>
